export const DOCUMENT_TYPE_SITE_SETTINGS = 'siteSettings';
